export var structureAndContentRelativePath = function (locale, brandId) { return brandId ? "/helpcenter/".concat(locale, "/contentAndStructure?brandId=").concat(brandId) : "/helpcenter/".concat(locale, "/contentAndStructure"); };
export var createStructureAndContentApi = function (baseUrl, http) {
    var apiUrl = function (locale, brandId) { return baseUrl + structureAndContentRelativePath(locale, brandId); };
    return {
        get: function (dto) {
            return http.get(apiUrl(dto.locale, dto.brandId));
        },
        updatePageAndSidebar: function (dto) {
            return dto.brandId ? http.put("".concat(apiUrl(dto.locale), "/pageAndSidebar?brandId=").concat(dto.brandId), dto) : http.put("".concat(apiUrl(dto.locale), "/pageAndSidebar"), dto);
        },
        updateHeader: function (dto) {
            return dto.brandId ? http.put("".concat(apiUrl(dto.locale), "/header?brandId=").concat(dto.brandId), dto) : http.put("".concat(apiUrl(dto.locale), "/header"), dto);
        },
        updateFooter: function (dto) {
            return dto.brandId ? http.put("".concat(apiUrl(dto.locale), "/footer?brandId=").concat(dto.brandId), dto) : http.put("".concat(apiUrl(dto.locale), "/footer"), dto);
        },
    };
};
//# sourceMappingURL=index.js.map